import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../../../services/generalService";
import { TransactionFeesSetConfigObj } from "../../../../utils/types";

const initialState: TransactionFeesSetConfigObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getTransactionFeesSetConfigData = createAsyncThunk(
  "config/getTransactionFeesSetConfigDataDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const transactionFeesSetConfigSlice = createSlice({
  name: "transactionFeesSetConfig",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionFeesSetConfigData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTransactionFeesSetConfigData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getTransactionFeesSetConfigData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default transactionFeesSetConfigSlice.reducer;
